export default __webpack_public_path__ + "static/media/mediaTypeMagazine.fe2d026b.svg";